export default function(n) {
  return 'other';
}
